import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EvacuationStatut, StatutRapportPrepose } from 'src/api/models';

@Component({
  selector: 'app-rapport-status',
  templateUrl: './rapport-status.component.html',
  styleUrls: ['./rapport-status.component.css']
})
export class RapportStatusComponent implements OnInit {

  @Input('status') public status: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetStatutRapport(s: StatutRapportPrepose) {
    if (s === undefined) {
      return '';
    } else {
      return this.translateService.instant('Rapports.RapportsPreposes.Statuts.' + StatutRapportPrepose[s]);
    }
  }

}
